import classNames from 'classnames'

import type { ReactElement, SyntheticEvent } from 'react'

import { DEVICE_TYPE } from '~/const'

import './styles.scss'

export interface ISwitchButton {
  application?: string
  content: string
  id: string
  isActive: boolean
  isDisabled?: boolean
}

export const getDefaultDeviceTypeSwitchButtons = ({ withWeb = true }: { withWeb?: boolean } = {}): ISwitchButton[] => [
  {
    content: 'Android',
    id: DEVICE_TYPE.ANDROID,
    isActive: false,
  },
  {
    content: 'iOS',
    id: DEVICE_TYPE.IOS,
    isActive: true,
  },
  ...(withWeb
    ? [
        {
          content: 'Web',
          id: DEVICE_TYPE.WEB,
          isActive: false,
        },
      ]
    : []),
]

export interface Props {
  backgroundColor?: 'light' | 'dark'
  buttons: ISwitchButton[]
  className?: string
  disabled?: boolean
  onButtonSelectionChange: (id: string, evt: SyntheticEvent<HTMLButtonElement>) => void
  onMouseEnter?: VoidFunction
  onMouseLeave?: VoidFunction
  size?: Exclude<SIZES, 'large'>
}

const SwitchButton = ({
  backgroundColor = 'light',
  buttons,
  className,
  disabled,
  onButtonSelectionChange,
  onMouseEnter,
  onMouseLeave,
  size = 'medium',
}: Props): ReactElement => {
  /** Local state */

  const switchButtonClasses = classNames('switch-button-component', size, `${backgroundColor}-background`, className, {
    'switch-button-component--disabled': disabled,
  })

  /** Handlers */

  const handleClick = (buttonId: string) => (evt: SyntheticEvent<HTMLButtonElement>) =>
    onButtonSelectionChange(buttonId, evt)

  /** Render */

  return (
    <div className={switchButtonClasses} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {buttons.map(({ content, id, isActive, isDisabled }) => (
        <button
          className={classNames('button', { 'button--active': isActive, 'button--disabled': disabled || isDisabled })}
          disabled={disabled || isDisabled}
          key={id}
          onClick={handleClick(id)}
        >
          {content}
        </button>
      ))}
    </div>
  )
}

export default SwitchButton
